// extracted by mini-css-extract-plugin
export default {"radio":"RejectModalView_radio__c-w1C","feedback":"RejectModalView_feedback__QgpOP"};